import { rootState } from "../store";

export const getToken = (state:rootState) => {
    return state.auth?.token || undefined;
}